import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageSquareWarning, Send } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatDeShort } from "@/lib/date";

export default function ComplaintFormButton({ kind, personId }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/complaint-forms/person/${kind}/${personId}`).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [kind, personId]); // eslint-disable-line
  if (!d) return null;
  const send = async () => {
    if (!window.confirm("Beschwerdebogen per E-Mail an den Teilnehmer senden?")) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/complaint-forms/send/${kind}/${personId}`);
      toast.success(`Beschwerdebogen an ${data.email} gesendet`);
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  const last = d.forms[0];
  return (
    <div className="border border-slate-200 bg-white px-5 py-3 flex items-center gap-3 flex-wrap mt-6" data-testid="complaint-form-card">
      <MessageSquareWarning size={15} strokeWidth={1.5} className="text-slate-400" />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500">Beschwerdebogen</div>
        <div className="text-xs text-slate-600" data-testid="complaint-form-status">
          {last ? `Zuletzt gesendet am ${formatDeShort(last.sent_at)} · ${last.submitted ? "beantwortet" : "offen"}` : "Noch nicht gesendet"}
          {d.complaints.length > 0 && ` · ${d.complaints.length} Beschwerde(n) im Register`}
        </div>
      </div>
      <button onClick={send} disabled={busy} data-testid="complaint-form-send-btn"
        className="px-4 py-2 text-xs font-medium border border-slate-300 hover:bg-slate-100 disabled:opacity-50 flex items-center gap-1.5">
        <Send size={12} strokeWidth={1.5} /> {busy ? "Sendet…" : "Beschwerdebogen senden"}
      </button>
    </div>
  );
}
